module.exports = __webpack_public_path__ + "img/PatioFurnitureAccessories.10b055f5.png";